import { watch, type ComputedRef } from "vue";

type ColorMap = Record<string, string>;

/**
 * Mirrors the customer brand color CSS custom properties onto <html>.
 *
 * App-root layouts apply `:style="settingsStore.colorSetup"` directly on their
 * outermost div, but `<dialog>` elements opened via `showModal()` enter the
 * browser's top layer and inherit CSS custom properties from the document
 * root, NOT from their DOM parent. Without this, modals (e.g. "Opret dokument
 * og åbn") render with Tailwind's default red instead of the customer's brand.
 */
export const useColorSetup = (colorSetup: ComputedRef<ColorMap | undefined>) => {
  watch(
    colorSetup,
    vars => {
      if (!vars) return;
      for (const [name, value] of Object.entries(vars)) {
        document.documentElement.style.setProperty(name, value);
      }
    },
    { immediate: true, deep: true }
  );
};
